import React from 'react';
// import { motion } from 'framer-motion';
// import { Link } from 'react-router-dom';

const ThankYouPage = () => {
  return (
    // <div className="min-h-screen flex items-center justify-center bg-green-50 w-full">
    //   <motion.div
    //     className="text-center p-8 bg-white rounded-xl shadow-lg"
    //     initial={{ scale: 0.8, opacity: 0 }}
    //     animate={{ scale: 1, opacity: 1 }}
    //     transition={{ duration: 0.5 }}
    //   >
    //     <h1 className="text-4xl font-bold text-green-600 mb-4">Thank You!</h1>
    //     <p className="text-gray-700 mb-6">
    //       Your message has been received. We will get back to you soon.
    //     </p>
    //     <Link
    //       to="https://muskowl.com"
    //       className="text-white bg-green-500 px-4 py-2 rounded hover:bg-green-600 transition"
    //     >
    //       Back to Home
    //     </Link>
    //   </motion.div>
    // </div>

    <section
      className="relative min-h-[90vh] w-full bg-cover bg-center py-10 px-5 md:px-20 border-t-[10px] border-b-[10px] border-blue-900 items-center flex"
      style={{ backgroundImage: "url('/assets/top-banner.png')" }}
    >
      <div className="container mx-auto flex justify-between items-center px-4 md:px-10">
        <div className="absolute inset-0 bg-white bg-opacity-30"></div>

        <div className="relative z-10 container mx-auto flex gap-10 ">
          <div className="space-y-5">
            {/* <Header /> */}
            <div className="grid justify-start items-center w-[80%]">
              <p className="text-xl md:text-3xl font-normal text-gray-800 text-center">
                <span className="pb-">Thank you for your submission.</span>
                <br />
                Our career expert will contact you soon. <br />
                If you would like to reach out to us first, feel free to call:
                <a
                  href="tel:18008896555"
                  className="text-[#282365] px-3 font-semibold text-2xl md:text-4xl"
                >
                  18008896555
                </a>
                or visit our website
                <a
                  href="https://www.spsu.ac.in"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#282365] px-3 font-semibold text-2xl md:text-4xl"
                >
                  www.spsu.ac.in
                </a>
                for course details.
              </p>
            </div>
          </div>

          {/* Right Section - Inquiry Form */}
          <div className="justify-end hidden md:flex">
            {/* <InquiryForm /> */}
          </div>
        </div>
      </div>
      {/* <div className="bg-[#282365] text-white text-3xl font-normal px-4 py-2 w-max rounded-md mt-3 hidden md:block z-[999] absolute top-[50%] left-[-10px] shadow-xl">
        <a className="pl-3 inline-block p-3" href="/form">
          <span>Applications Open for</span> <br />
          <span className="text-4xl font-bold inline-block">YEAR 2025</span>
        </a>
      </div> */}

      <div className="absolute bottom-0 right-0 hidden md:block">
        <img
          className="h-[480px] w-[auto]"
          src="/assets/banner-girl.png"
          alt=""
        />
      </div>
    </section>
  );
};

export default ThankYouPage;
